import { SnackBarParams } from '../models/snackbar-params'

export class SnackBarService {

    /**
   * Display a snackbar
   *
   * @param message - Required : message to display
   * @param params - Optional : Params for snackar (redirectTitle, redirectUrl, duration, snackBarContainerId, url)
   * @description snackBarParams Object :
   * @description snackBarContainerId : identifier of the snackbar container should be displayed in.
   * @description url : url of the method that will generate and return the html code to display
   * @description redirectTitle - Optional : title displayed on redirect link
   * @description redirectUrl - Optional : url of redirect link
   * @description duration - Optional : snackbar display time (default = 3 sec)
   * @returns void
   *
   */
    static load<T>(message: string, params?: SnackBarParams) {

        var snackBarParams = new SnackBarParams();

        // loading the parameters received
        if (params)
            snackBarParams = params;

        //loading container
        let snackBarContainer = document.getElementById(snackBarParams.snackBarContainerId);

        // generate snackbarid
        var snackBarId = "snackbar_" + this.generateUniqueID(Math.random().toString());

        // create Url with parmas
        let url = snackBarParams.url + "&snackbarId=" + snackBarId + "&message=" + message + "&redirectTitle=" + snackBarParams.redirectTitle + "&redirectUrl=" + snackBarParams.redirectUrl + '&isMessageTranslated=' + snackBarParams.isMessageTranslated + '&isTitleTranslated=' + snackBarParams.isTitleTranslated;

        if (snackBarContainer) {
            fetch(url) // ajax call (get snackBar html)
                .then((response) => {
                    return response.text(); // return html as text
                })
                .then((result) => { // insert html 
                    if (snackBarContainer) // in an identified element
                    {
                        snackBarContainer.insertAdjacentHTML('beforeend', result);
                        // get snackBar element
                        let snackBar = document.getElementById(snackBarId);
                        const timeoutId = setTimeout(() => {
                            const currentSnackbar = document.getElementById(snackBarId);
                            // remove snackbar
                            if (currentSnackbar) {
                                currentSnackbar?.remove();
                            }
                        }, snackBarParams.duration);
                        if (!snackBarParams.redirectUrl || snackBarParams.redirectUrl.length <= 0)
                            snackBar?.lastElementChild?.remove();
                    }
                })
        }
    }

    static generateUniqueID(inputString: string): string {
        let crc = 0xFFFFFFFF;

        for (let i = 0; i < inputString.length; i++) {
            let charCode = inputString.charCodeAt(i);
            crc ^= charCode;

            for (let j = 0; j < 8; j++) {
                if ((crc & 1) === 1) {
                    crc = (crc >>> 1) ^ 0xEDB88320;
                } else {
                    crc = crc >>> 1;
                }
            }
        }

        crc = crc ^ 0xFFFFFFFF;
        return crc.toString(16);
    }
}